import { EMPTY_LIST } from '../../../constants/common'
import { NotificationInline } from '../../Notification'

import { getSortedNotifications } from './FormHeader.utils'

import * as styles from './FormHeader.module.css'

function FormHeader({
  className = styles.FormHeader,
  notificationClassName,
  notifications = EMPTY_LIST,
  ref,
}) {
  const sortedNotifications = getSortedNotifications(notifications)

  return notifications.length > 0 ? (
    <div className={className} ref={ref}>
      {sortedNotifications.map(notification => (
        <NotificationInline
          {...notification}
          className={notificationClassName}
          key={notification.text}
        />
      ))}
    </div>
  ) : null
}

export default FormHeader
